/* F-62: de aankondigingsbalk wisselt door te schuiven (zoals de bron) in plaats van te vervagen. De huidige tekst schuift naar links weg, de volgende komt van
   rechts binnen. Horizon zet zelf aria-hidden op de dia's; dit script volgt dat attribuut en speelt er een beweging bij af (700 ms, snel begin, zacht einde). */
(function () {
  'use strict';

  var dias = document.querySelectorAll('.announcement-bar__slide');
  if (!dias.length) return;

  var start = Date.now();
  var duur = 700;
  var gang = 'cubic-bezier(0.22, 1, 0.36, 1)';

  var waarnemer = new MutationObserver(function (lijst) {
    // de eerste seconden zet Horizon alleen de beginstand; daar hoort geen beweging bij
    if (Date.now() - start < 2500) return;
    for (var i = 0; i < lijst.length; i++) {
      var dia = lijst[i].target;
      if (!dia.animate) continue;
      var weg = dia.getAttribute('aria-hidden') === 'true';
      var stand = weg ? 'weg' : 'in';
      // Horizon zet het attribuut soms opnieuw op dezelfde waarde: dan geen beweging
      if (dia.getAttribute('data-bri-balk-stand') === stand) continue;
      dia.setAttribute('data-bri-balk-stand', stand);
      dia.animate(
        weg
          ? [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }]
          : [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
        { duration: duur, easing: gang }
      );
    }
  });

  for (var d = 0; d < dias.length; d++) {
    dias[d].setAttribute('data-bri-balk-stand', dias[d].getAttribute('aria-hidden') === 'true' ? 'weg' : 'in');
    waarnemer.observe(dias[d], { attributes: true, attributeFilter: ['aria-hidden'] });
  }
})();
